import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import  { WarehouseLocationManipulationView } from "./warehouseLocationManipulation-view"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { warehouseFloorSelectorViewModel } from "../warehouseFloorManipulation/warehouseFloorManipulation-viewModel";

export class WarehouseLocationManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت Layout انبار ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehouseLocation = ObservableArray.create<warehouseLocation>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.warehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, false, false, true, true, false);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.selectedWarehouseId = w.id;
            this.selectedWarehouseName = w.title;
            this.refresh();
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseLocationManipulationView();
    }
    public getTypeId(): string {
        return "VM-70AADC49-9239-48B3-BDB2-1EE50D63B9AE"
    }

    public set warehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName;} private _selectedWarehouseName: string;
    public set selectedWarehouseId(v: string) { this._selectedWarehouseId = v; } public get selectedWarehouseId(): string { return this._selectedWarehouseId;} private _selectedWarehouseId: string;
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set warehouseLocation(v: ObservableArray<warehouseLocation>) { this._warehouseLocation = v; } public get warehouseLocation(): ObservableArray<warehouseLocation> { return this._warehouseLocation;} private _warehouseLocation: ObservableArray<warehouseLocation>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehousePlaces',{
                FilteringInformation:filteringInformation,
                WarehouseParty:this.selectedWarehouseId
            });
            let rowNumber = 1;
            this.warehouseLocation.update(...result.WarehousePlaces.map(q=>{
                let r = new warehouseLocation(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.name = q.Name;   
                r.floor = q.FloorName;   
                r.floorId = q.FloorId;   
                r.from = moment.utc(q.From);
                r.until = q.Until==null? null : moment.utc(q.Until);
                r.canInvalidate = q.Until==null;         
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestWarehouseLocationCreation(){
        if(this.selectedWarehouseId == null){
            await this.messageBoxConfirmWarning('انبار انتخاب نشده است','عدم امکان ثبت');
            return;
        }
        let editor = new warehouseLocationEditor(this,new InsertServerUpdater(),this.selectedWarehouseId);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async warehouseLocationUpdater(warehouseLocation:warehouseLocation){
        let editor = new warehouseLocationEditor(this,new UpdateServerUpdater(),this.selectedWarehouseId);
        warehouseLocation.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/WarehouseServices/DeleteWarehouseLocation',{
                WarehousePlace:id
            });
            await this.messageBoxConfirmSuccess('Layout انبار غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class warehouseLocation extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseLocationManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate;} private _canInvalidate: boolean;
    public set floor(v: string) { this._floor = v; } public get floor(): string { return this._floor;} private _floor: string;
    public set floorId(v: string) { this._floorId = v; } public get floorId(): string { return this._floorId;} private _floorId: string;
    
    
    private _typedParent:WarehouseLocationManipulationViewModel;

    cloneTo(warehouseLocation:warehouseLocation){
        warehouseLocation.id = this.id;
        warehouseLocation.name = this.name;
        warehouseLocation.setFloor(this.getFloor(), this.floor);
    }

    setFloor(id: string, name: string) {
        this.floorId = id;
        this.floor = name;
    }

    getFloor() {
        return this.floorId;
    } 

    async edit(){
        this._typedParent.warehouseLocationUpdater(this);
    }  

    async inactive():Promise<void>{
        if(this.canInvalidate) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن Layout');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }

}

interface IServerUpdater{
    execute(warehouseLocation:warehouseLocation,warehouseId:string):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' Layout با موفقیت ثبت شد.';
    }
    async execute(warehouseLocation: warehouseLocation,warehouseId:string): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateNewWarehouseLocation',{
            WarehouseId:warehouseId,
            WarehouseFloorId:warehouseLocation.getFloor(),
            LocationName:warehouseLocation.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'Layout با موفقیت به روز رسانی شد.';
    }
    async execute(warehouseLocation: warehouseLocation,warehouseId:string): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateWarehouseLocation',{
            WarehousePlaceId:warehouseLocation.id,
            WarehouseFloorId:warehouseLocation.getFloor(),
            LocationName:warehouseLocation.name
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class warehouseLocationEditor extends warehouseLocation implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:WarehouseLocationManipulationViewModel,serverUpdater:IServerUpdater, warehouseId) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.warehouseId = warehouseId;
        this.FloorSelector = new warehouseFloorSelectorViewModel(this);
    }

    closePopup(resultCode: string = null) {
    }
    private _serverUpdater:IServerUpdater;
    private warehouseId : string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set FloorSelector(v: warehouseFloorSelectorViewModel) { this._FloorSelector = v; } public get FloorSelector(): warehouseFloorSelectorViewModel { return this._FloorSelector;} private _FloorSelector: warehouseFloorSelectorViewModel;
    
    clearFloor(){
        this.FloorSelector.selectedItem = null;
    }

    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام Layout مشخص نشده است.')
        }
        return result;
    }

    setFloor(id: string, name: string) {
        this.FloorSelector.selectById(id);
    }
    
    getFloor() {
        return this.FloorSelector.selectedItem?.id;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت Layout');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this, this.warehouseId);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}

export class warehouseLocationMultiSelectorViewModel extends MultiSelectorBaseViewModel<warehouseLocationForSelector>{
    
    constructor(parentViewModel: ViewModel,warehouseId:string) {
        super(parentViewModel);
        this.warehouseId = warehouseId;
    }
    
    private _warehouseId : string;public get warehouseId() : string { return this._warehouseId;} public set warehouseId(v : string) {
        this._warehouseId = v;
        this.refresh();
    }
    
    protected async loadData(): Promise<warehouseLocationForSelector[]> {
        if(this.warehouseId==null || this.warehouseId=='')
            return [];

        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehousePlaces',{
            WarehouseParty:this.warehouseId
        });    
        return result.WarehousePlaces.map(q=>{
            let r = new warehouseLocationForSelector(this);
            r.id=q.Id;
            r.title = q.Name;
            return r;
        }); 
    }
    
}

export class warehouseLocationSearchSelectorViewModel extends SearchableSelectorBaseViewModel<warehouseLocationForSelector>{
    
    constructor(parentViewModel: ViewModel,warehouseId:string) {
        super(parentViewModel);
        this.warehouseId = warehouseId;
    }
    
    private _warehouseId : string;public get warehouseId() : string { return this._warehouseId;} public set warehouseId(v : string) {
        this._warehouseId = v;
        this.refresh();
    }
    
    protected async loadData(searchedText: string): Promise<warehouseLocationForSelector[]> {
        if(this.warehouseId==null || this.warehouseId=='')
            return [];

        let result = await ServerConnection.callServer('/Complex/WarehouseServices/SearchWarehousePlaces',{
            SearchText:searchedText,
            ResultCount:20,
            WarehouseParty:this.warehouseId
        });    
        return result.Locations.map(x=>this.convertSingle(x)); 
    }
    
    protected async loadById(id: string): Promise<warehouseLocationForSelector> {
        let result = await ServerConnection.callServer('Complex/CrmServices/SearchWarehousePlacesById',{
            Id:id
        });    
        return this.convertSingle(result.Location);
    }
    
    private convertSingle(dto:any):warehouseLocationForSelector{
        var p = new warehouseLocationForSelector(this);
        p.id = dto.Id;
        p.title = dto.Name;
        return p;
    }
}

class warehouseLocationForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}